import { Divider } from 'antd';
import styled from 'styled-components';

import { Link } from '../../../ui-helpers';
import { mediaSize } from '../../../../styles';
import { SvgWrapper as SvgWrap } from '../styled-components';

export const CountersWrapper = styled.div`
  grid-area: request-counters-wrap;

  display: flex;
  align-items: center;
  margin-left: 10px;
  width: 160px;
  justify-content: flex-end;
  
  @media(max-width: ${mediaSize.tablet}) {
    display: none;
  }
`;

export const CounterItem = styled(Link)`
  display: flex;
  align-items: center;
  color: ${({ color }) => color};
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    color: ${({ color }) => color};
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
  pointer-events: none;

  &.label-wrapper {
    margin-left: 10px;
    pointer-events: auto;
    width: 17px;
  }
`;

export const StyledDivider = styled(Divider)`
  flex-shrink: 0;
`;

export const SvgWrapper = styled(SvgWrap)`
  top: 0;
  height: 24px;
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/counters/styled-components.js